import React from 'react';
import PlanSelector from '../../components/PlanSelector';

// The subscribe states (no active subscription) are rendered by ParentPage as a
// dedicated, full-width gate — never as a banner stacked above the dashboard.
// Keeping it focused (no child bubbles / study plans behind it) lets the parent
// resolve billing without distraction. See docs/design-subscription-trial-ownership.md.
const GatePanel = ({ children }) => (
    <div className="flex justify-center pt-4 pb-16">
        <div className="w-full max-w-xl bg-white rounded-2xl border border-gray-200 shadow-sm p-8">
            {children}
        </div>
    </div>
);

// Payment-retry states (the parent has a subscription, but a charge failed) stay
// a lighter inline banner above the dashboard: they keep grace access while the
// parent updates their card via the billing portal.
const PaymentBanner = ({ children }) => (
    <div className="border border-red-500 border-2 p-4 mb-8">{children}</div>
);

const SubscriptionActionMessage = ({ action }) => {
    switch (action.action) {
        case 'update_payment_past_due':
            return (
                <PaymentBanner>
                    <div className="mb-4">Your subscription is past due. Please update your payment information.</div>
                    <a href={action.billing_portal_url}
                        target="_blank" rel="noopener noreferrer"
                        className="bg-blue-500 text-white py-2 px-4 rounded cursor-pointer">
                        Pay subscription
                    </a>
                </PaymentBanner>
            );
        case 'update_payment_unpaid':
            return (
                <PaymentBanner>
                    <div className="mb-4">Your subscription is unpaid. Please update your payment information.</div>
                    <a href={action.billing_portal_url}
                        target="_blank" rel="noopener noreferrer"
                        className="bg-blue-500 text-white py-2 px-4 rounded cursor-pointer">
                        Pay subscription
                    </a>
                </PaymentBanner>
            );
        case 'none':
            return '';
        case 'create_new':
        case 'create_new_has_canceled':
        default:
            return (
                <GatePanel>
                    <div className="text-lg font-semibold text-darkrock mb-4">
                        Please subscribe to continue using Learnforest
                    </div>
                    <PlanSelector
                        context="subscribe"
                        surface="subscription_action"
                        defaultPlan="monthly_family"
                    />
                </GatePanel>
            );
    }
};

export default SubscriptionActionMessage;
